import { bunja } from 'bunja';
import { atom } from 'jotai';

export const yourPositionsBunja = bunja(() => {
  const showAllSymbolAtom = atom(true);
  const positionTabTypeAtom = atom<'open' | 'pending'>('open');

  return { showAllSymbolAtom, positionTabTypeAtom };
});
